/** @format */

export const INITIAL_STATE = {
  data: {},
};
